import { CreateOrUpdateAdditionalReferenceRequest } from '../../../../api/models'
import { AdditionalReference, AdditionalReferenceParentType } from './types'

export const ParentTypeToRequestParentIdField: Record<AdditionalReferenceParentType, keyof CreateOrUpdateAdditionalReferenceRequest> = {
  consignment: 'consignmentId',
  houseConsignment: 'houseConsignmentId',
  consignmentItem: 'consignmentItemId',
} as const

export type AdditionalReferenceCreate = Omit<AdditionalReference, 'id' | 'parentId' | 'parentType'> & {
  transitOperationId: number
}

export type AdditionalReferenceUpdate = Omit<AdditionalReference, 'parentId' | 'parentType'> & {
  transitOperationId: number
}
